import { ErrorScreen } from "@dash/skeleton";
import { useTheme } from "@emotion/react";
import React from "react";

import { CubeCollapsedTileSkeletonStack } from "./CubeCollapsedTileSkeletonStack";
import type { CustomerAvailabilityByRegionRow } from "./parseCustomerAvailabilityByRegionRows";

type Props = {
  row: CustomerAvailabilityByRegionRow | undefined;
  error: Error | null;
  isLoading: boolean;
  regionLabel: string;
};

export const MyRegionAvailabilityBlock: React.FC<Props> = ({ row, error, isLoading, regionLabel }) => {
  const theme = useTheme();
  if (error) {
    return <ErrorScreen>{error.message}</ErrorScreen>;
  }
  if (isLoading) {
    return <CubeCollapsedTileSkeletonStack />;
  }
  if (row === undefined) {
    return <div css={{ color: theme.colors.secondaryText, fontSize: "0.875rem" }}>Brak danych.</div>;
  }
  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem", fontSize: "0.9375rem" }}>
      <div css={{ color: theme.colors.secondaryText }}>Region: {regionLabel}</div>
      <div>Klienci: {row.total}</div>
      <div>Z uzupełnioną dostępnością: {row.withAvailability}</div>
    </div>
  );
};
